import { TrackInfo } from "../../model/track-info";
import { TrackActionResult } from "../../model/track-action-result";

export class BirthCountryInvestActionV2 {

    public static execute(data: any) {
        if (data.personalData.countryOfBirth === 'BR' || data.personalData.countryOfBirth === 'BRA' || data.personalData.countryOfBirth === '648') {
            const trackInfo = new TrackInfo('personal-data', ['personal-data', 'birth-state']);
            return new TrackActionResult(data, trackInfo);
        } else {
            const trackInfo = new TrackInfo('nationality', ['personal-data', 'nationality']);
            return new TrackActionResult(data, trackInfo);
        }
    }
}